var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _vm.ready ? _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "flex flex-col xl:flex-row items-center justify-conter w-full gap-x-4"
  }, [_c('el-form-item', {
    staticClass: "w-full",
    attrs: {
      "prop": "first_name",
      "label": _vm.$t('First Name'),
      "rules": {
        required: true,
        message: _vm.$t('Please input your first name'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: _vm.form.first_name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "first_name", $$v);
      },
      expression: "form.first_name"
    }
  })], 1), _c('el-form-item', {
    staticClass: "w-full",
    attrs: {
      "prop": "last_name",
      "label": _vm.$t('Last Name'),
      "rules": {
        required: true,
        message: _vm.$t('Please input your last name'),
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    model: {
      value: _vm.form.last_name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "last_name", $$v);
      },
      expression: "form.last_name"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-[18px] text-[#3c4a5d] font-bold leading-[40px]"
  }, [_c('span', {
    staticClass: "text-[#f56c6c]"
  }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t('Phone No.')))]), _c('div', {
    staticClass: "flex items-center justify-conter w-full gap-x-4"
  }, [_c('div', {
    staticClass: "w-[30%] xl:!w-[25%]"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phone_area_code",
      "required": ""
    }
  }, [_c('phone-area-code-select', {
    attrs: {
      "disabled": _vm.phoneDisabled
    },
    model: {
      value: _vm.form.phone_area_code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone_area_code", $$v);
      },
      expression: "form.phone_area_code"
    }
  })], 1)], 1), _c('div', {
    staticClass: "grow"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.phoneDisabled
    },
    model: {
      value: _vm.form.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1)], 1)]), _c('el-form-item', {
    staticClass: "!mb-[44px]",
    attrs: {
      "prop": "password",
      "label": _vm.$t('Password')
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": ""
    },
    model: {
      value: _vm.form.password,
      callback: function ($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  }), _vm.showHint ? _c('div', {
    staticClass: "el-form-item__error !text-[#6D7786]"
  }, [_vm._v(" " + _vm._s(_vm.$t("8-16 characters with numbers, upper and lower case")) + " ")]) : _vm._e()], 1), _c('el-form-item', {
    attrs: {
      "prop": "country_region",
      "label": _vm.$t('Country/Region'),
      "rules": {
        required: true,
        message: _vm.$t('Please select your country/region'),
        trigger: 'blur'
      }
    }
  }, [_c('el-select', {
    staticClass: "w-full text-left",
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function ($event) {
        _vm.loadDistrict();

        _vm.form.district = null;

        _vm.$forceUpdate();
      }
    },
    model: {
      value: _vm.form.country_region,
      callback: function ($$v) {
        _vm.$set(_vm.form, "country_region", $$v);
      },
      expression: "form.country_region"
    }
  }, _vm._l(_vm.ctyOptions, function (i) {
    return _c('el-option', {
      key: i.value,
      attrs: {
        "label": i.label,
        "value": i.value
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('Email Address')
    }
  }, [_c('el-input', {
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(_vm._s(_vm.$t("Birth Date")) + " "), _c('span', {
    staticClass: "font-normal text-[#6D7786]"
  }, [_vm._v("(" + _vm._s(_vm.$t("Optional")) + ")")])]), _c('div', {
    staticClass: "flex flex-col xl:flex-row items-center justify-between w-full gap-x-4"
  }, [_c('el-form-item', {
    staticClass: "w-full",
    attrs: {
      "prop": "birth_date_year"
    }
  }, [_c('span', {
    staticClass: "absolute top-[0] bottom-[0] right-[48px] my-auto text-[16px] z-[1]"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("Year")))])]), _c('el-date-picker', {
    staticClass: "!w-full",
    attrs: {
      "type": "year",
      "placeholder": "YYYY",
      "value-format": "yyyy"
    },
    model: {
      value: _vm.form.birth_date_year,
      callback: function ($$v) {
        _vm.$set(_vm.form, "birth_date_year", $$v);
      },
      expression: "form.birth_date_year"
    }
  })], 1), _c('el-form-item', {
    staticClass: "w-full",
    attrs: {
      "prop": "birth_date_month"
    }
  }, [_c('span', {
    staticClass: "absolute top-[0] bottom-[0] right-[48px] my-auto text-[16px] z-[1]"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("Month")))])]), _c('el-select', {
    staticClass: "!w-full month-select-left",
    attrs: {
      "clearable": "",
      "placeholder": "MM"
    },
    model: {
      value: _vm.form.birth_date_month,
      callback: function ($$v) {
        _vm.$set(_vm.form, "birth_date_month", $$v);
      },
      expression: "form.birth_date_month"
    }
  }, _vm._l(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'], function (i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "label": i,
        "value": i
      }
    });
  }), 1)], 1)], 1), _c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(_vm._s(_vm.$t("Gender")) + " "), _c('span', {
    staticClass: "font-normal text-[#6D7786]"
  }, [_vm._v("(" + _vm._s(_vm.$t("Optional")) + ")")])]), _c('el-form-item', {
    attrs: {
      "prop": "gender"
    }
  }, [_c('el-radio-group', {
    staticClass: "w-full disabled:!bg-[#f5f7fa] disabled:!border-[#e4e7ed] disabled:!text-[#c0c4cc] disabled:!cursor-not-allowed",
    model: {
      value: _vm.form.gender,
      callback: function ($$v) {
        _vm.$set(_vm.form, "gender", $$v);
      },
      expression: "form.gender"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "male"
    }
  }, [_vm._v(_vm._s(_vm.$t("Male")))]), _c('el-radio', {
    attrs: {
      "label": "female"
    }
  }, [_vm._v(_vm._s(_vm.$t("Female")))])], 1)], 1), _c('label', {
    staticClass: "el-form-item__label float-none"
  }, [_vm._v(_vm._s(_vm.$t("Interests")) + " "), _c('span', {
    staticClass: "font-normal text-[#6D7786]"
  }, [_vm._v("(" + _vm._s(_vm.$t("Optional")) + ")")])]), _c('el-form-item', [_c('div', {
    staticClass: "multi-selector relative p-[0_30px_0_15px] bg-[rgba(231,233,235,0.6)] border-[1.5px] border-solid border-[#CED2D7] cursor-pointer",
    class: _vm.active == true ? 'border-b-[#78C147] border-b-[3px]' : '',
    on: {
      "click": function ($event) {
        _vm.active = !_vm.active;
      }
    }
  }, [_c('div', {
    staticClass: "text-[18px] text-[#9DA5AE]"
  }, [_vm._v(" " + _vm._s(_vm.selectedInterestText) + " ")]), _c('div', {
    staticClass: "absolute top-[2px] bottom-[0] right-[12px] m-[auto_0]"
  }, [_c('i', {
    staticClass: "el-icon-arrow-down text-[#C0C4CC]"
  })])]), _c('div', {
    staticClass: "absolute top-[calc(100%+8px)] left-[0] right-[0] m-[0_auto] z-[2]"
  }, [_c('slide-up-down', {
    attrs: {
      "active": _vm.active,
      "duration": 1000
    }
  }, [_c('div', {
    staticClass: "bg-[#fff] shadow-lg rounded-[4px] p-[0.75rem] max-h-[300px] overflow-y-auto"
  }, [_c('div', {
    staticClass: "text-[#6D7786]"
  }, [_vm._v(" " + _vm._s(_vm.$t("You can select max. 3 interests")) + " (" + _vm._s(_vm.form.interest.length) + "/3) ")]), _c('el-checkbox-group', {
    attrs: {
      "min": 0,
      "max": 3
    },
    model: {
      value: _vm.form.interest,
      callback: function ($$v) {
        _vm.$set(_vm.form, "interest", $$v);
      },
      expression: "form.interest"
    }
  }, _vm._l(_vm.intOptions, function (i, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": i.value
      }
    }, [_vm._v(_vm._s(i.label))]);
  }), 1)], 1)])], 1)]), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: _vm.form.receive_email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "receive_email", $$v);
      },
      expression: "form.receive_email"
    }
  }, [_vm._v(_vm._s(_vm.$t("I would like to receive email about news and promotion")) + " ")])], 1), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: _vm.form.receive_newsletter,
      callback: function ($$v) {
        _vm.$set(_vm.form, "receive_newsletter", $$v);
      },
      expression: "form.receive_newsletter"
    }
  }, [_vm._v(_vm._s(_vm.$t("I would like to receive promotion booklet")))])], 1), _vm.form.receive_newsletter ? _c('el-form-item', {
    attrs: {
      "prop": "district",
      "label": _vm.$t('District'),
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "w-full",
    attrs: {
      "placeholder": _vm.$t('Select your district')
    },
    model: {
      value: _vm.form.district,
      callback: function ($$v) {
        _vm.$set(_vm.form, "district", $$v);
      },
      expression: "form.district"
    }
  }, _vm._l(_vm.districtOptions, function (i, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": i.label,
        "value": i.value
      }
    });
  }), 1)], 1) : _vm._e(), _vm.form.receive_newsletter ? _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": _vm.$t('Detail Address'),
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.form.address,
      callback: function ($$v) {
        _vm.$set(_vm.form, "address", $$v);
      },
      expression: "form.address"
    }
  })], 1) : _vm._e(), _vm.recaptchaConfig && !(_vm.mode == 'update' || _vm.mode == 'transfer') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('Verification'),
      "required": "",
      "prop": "recaptcha"
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.recaptcha,
      expression: "form.recaptcha"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('Please enter the verification code')
    },
    domProps: {
      "value": _vm.form.recaptcha
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "recaptcha", $event.target.value);
      }
    }
  }), _c('img', {
    staticClass: "ml-2 inline-block align-middle cursor-pointer",
    staticStyle: {
      "height": "48px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.recaptchaConfig.image,
      "alt": "recaptcha"
    },
    on: {
      "click": _vm.refreshRecaptcha
    }
  })])]) : _vm._e(), _c('el-form-item', [_c('el-button', {
    staticClass: "green-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.submitForm('form');
      }
    }
  }, [_vm.mode == 'update' || _vm.mode == 'transfer' ? [_vm._v(" " + _vm._s(_vm.$t("Update Account")) + " ")] : [_vm._v(" " + _vm._s(_vm.$t("Create Account")) + " ")]], 2)], 1), _c('div', {
    staticClass: "text-[#6D7786]"
  }, [_vm._v(" " + _vm._s(_vm.$t("By create account, you agree to our")) + " "), _c('a', {
    staticClass: "link !text-[#6D7786]",
    attrs: {
      "href": "https://www.overlander.com.hk/terms_and_regulation"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("Terms & Conditions")) + " ")])])])], 1) : _c('el-skeleton', {
    attrs: {
      "animated": ""
    }
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };